var React = require('react');

function IconBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H11.6412L16.6303 4.2L11.6412 8.4H0V0Z"}));
}

IconBookmark.defaultProps = {"viewBox":"0 0 17 9","fill":"none"};

module.exports = IconBookmark;

IconBookmark.default = IconBookmark;
